import React from 'react';
import Register from '../../components/extern/LoginRegisterReset/Register';

const RegisterPage = () => {
  return (
    <main>
      <Register />
    </main>
  );

};

export default RegisterPage;
